import React, { useState } from "react";
import { useSelector } from "react-redux";
import openListIcon from '../../lms-shared/assests/UI/openListIcon.png'
import classes from './SelectBtnStyle.module.css'

const SelectBtnStyle = ({ onChange, value, children }) => {

    const [showList, setShowList] = useState(false)
    const texts = useSelector((state) => state.translate.texts);

    const chooseOption = (name, value) => {
        setShowList(false)
        onChange(name, value)
    }

    return <div className={classes.SelectContainer} onClick={() => setShowList(prev => !prev)}>

        <div className={classes.Input}>
            <div className={classes.Text}>{value}</div>
            <img className={classes.Img} src={openListIcon} alt={"openListIcon"} />
        </div>

        {showList && <div className={classes.Options}>
            {children.length > 0 ? children?.map(option =>
                <option key={option.key} className={classes.Option} onClick={() => chooseOption(option.props.name, option.props?.value)}>{option.props.children}</option>)
                :
                <option className={`${classes.Option} ${classes.NoResultsFound}`}> {texts.noResultsFound}</option>
            }
        </div>}
    </div>

}


const SelectOption = ({ value, children }) => {
    return <></>
}

export { SelectBtnStyle, SelectOption };